import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANG, getStoredLang } from './langs';
import { resources } from './resources';

i18n.use(initReactI18next).init({
    resources,
    lng: getStoredLang(),
    fallbackLng: DEFAULT_LANG,
    interpolation: { escapeValue: false },
    returnNull: false,
});

export default i18n;
